<div class="aa-shell">
  <header
    aaHeader
    [isShadowVisible]="uiStore.isHeaderShadowVisible()"
  >
  </header>

  <main class="aa-shell__main">
    <div class="aa-shell__content">
      <router-outlet/>
    </div>
  </main>
</div>
